import { useSelector } from 'react-redux';
import RestockNotificationsWizard from '../RestockNotificationsWizard';
import { restockButtonData, restockModals } from '../../../mock/globalAPI';
import DetailsModal from '../../global/DetailsModal';
import { ProductDto } from '../../../types/schema';
import { getProductDetails } from '../../../store/selectors/product.selectors';
import { getWindowWidth } from '../../../store/selectors/ui.selectors';

const { text: restockText, components: [restockComponent] } = restockButtonData;

interface RestockWizardProps {
  productDetails: ProductDto | null;
  windowWidth: number;
}

export const renderRestockWizard = ({
  productDetails,
  windowWidth,
// eslint-disable-next-line react/display-name -- not a react function component
}: RestockWizardProps) => (onClose: () => void) => (
  <RestockNotificationsWizard
    productDetails={productDetails ?? {}}
    mobile={windowWidth < 920}
    modals={restockModals}
    onClose={onClose}
  />
);

const renderRestockButton = (onClick: () => void) => (
  <div
    className="pdp-add-button btn btn-charcoal"
    role="button"
    onClick={onClick}
  >
    <span>{restockText}</span>
  </div>
);

const RestockButton = () => {
  const productDetails: ProductDto | null = useSelector(getProductDetails);
  const windowWidth = useSelector(getWindowWidth);

  return (
    <div className="pdp-add">
      <DetailsModal
        teaserRenderer={renderRestockButton}
        componentToRender={renderRestockWizard({
          productDetails,
          windowWidth,
        })}
        containerClassName={'restock-notifications'}
        backgroundColor={restockComponent.backgroundColor}
      />
    </div>
  );
};

export default RestockButton;
